




























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import MessagesHistory from "@/modules/messaging/components/MessagesHistory.vue";
import PlushieInfo from "@/modules/plushie/components/PlushieInfo.vue";
import ArtworkGallery from "@/modules/plushie/components/ArtworkGallery.vue";
import FinishedProductPhotosGallery from "@/modules/quality-inspection/components/FinishedProductPhotosGallery.vue";
import LoadingSpinner from "@/lib/components/LoadingSpinner.vue";

import dataStore from "@/store";
import PlushieStore from "@/modules/plushie/store";
import Plushie from "@/modules/plushie/plushie.model";

import AcceptationForm from "./AcceptationForm.vue";
import RejectionForm from "./RejectPage/RejectionForm.vue";

import CustomerPreviewStore from "../store";

@Component({
  metaInfo() {
    const component = this as RejectPage;

    let titlePrefix = "";
    if (component.plushie != null) {
      titlePrefix = component.plushie.storeItemId + " - ";
    }

    return {
      title: titlePrefix + "Design Clarification",
    };
  },
  components: {
    LoadingSpinner,
    MessagesHistory,
    RejectionForm,
    PlushieInfo,
    ArtworkGallery,
    FinishedProductPhotosGallery,
    AcceptationForm,
  },
})
export default class RejectPage extends Vue {
  @Prop({ required: true })
  public readonly plushieId!: string;

  private fCustomerPreviewDataStore: CustomerPreviewStore;
  private fPlushieDataStore: PlushieStore;

  private fIsLoading = true;
  private fHasAutoScrolled = false;

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  get isDisabled(): boolean {
    return this.fCustomerPreviewDataStore.isPlushieProcessing(this.plushieId);
  }

  get plushie(): Plushie | undefined {
    return this.fPlushieDataStore.getPlushieById(this.plushieId);
  }

  constructor() {
    super();
    this.fCustomerPreviewDataStore = getModule(CustomerPreviewStore, dataStore);
    this.fPlushieDataStore = getModule(PlushieStore, dataStore);
  }

  public async onMessagesLoaded(): Promise<void> {
    if (this.fHasAutoScrolled) {
      return;
    }

    this.fHasAutoScrolled = true;
    const rejectionForm = this.$refs["rejection-form"] as
      | InstanceType<typeof RejectionForm>
      | undefined;

    if (!rejectionForm) {
      return;
    }

    await this.$nextTick();

    rejectionForm.$el.scrollIntoView({ behavior: "smooth", block: "end" });
  }

  private async getPlushieData(plushieId: string): Promise<void> {
    await this.fPlushieDataStore.loadPlushieById({
      id: plushieId,
    });
  }

  @Watch("plushieId", { immediate: true })
  private async onPlushieIdChange(): Promise<void> {
    if (!this.plushieId) {
      return;
    }

    this.fIsLoading = true;
    this.fHasAutoScrolled = false;

    try {
      await this.getPlushieData(this.plushieId);
    } finally {
      this.fIsLoading = false;
    }
  }
}
